import { Link } from "wouter";
import { ArrowLeft } from "lucide-react";

/**
 * Small "Back to Home" link for simple static pages (About, Contact,
 * Privacy, Terms, Blog list) that don't have a category/tool breadcrumb
 * of their own. These pages are often short enough that the scroll-gated
 * FloatingNavButtons never appear, so this gives a real, always-visible
 * way back at the top of the page too.
 */
export function BackToHomeLink() {
  return (
    <Link
      href="/"
      className="inline-flex items-center text-sm text-muted-foreground hover:text-foreground transition-colors mb-4"
    >
      <ArrowLeft className="mr-1.5 h-3.5 w-3.5" /> Back to Home
    </Link>
  );
}
